// src/firebase.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
   apiKey: "AIzaSyCSXfHKOoJjq_bVuGSA7IFsRTyR1KxDmXA",
  authDomain: "embexpart-eac4f.firebaseapp.com",
  databaseURL: "https://embexpart-eac4f.firebaseio.com",
  projectId: "embexpart-eac4f",
  storageBucket: "embexpart-eac4f.appspot.com",
  messagingSenderId: "198603968155",
  appId: "1:198603968155:web:b1f8f3121ce8adc4c8003e"
};




const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
